// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAcceptInvitationRequest = z.object({
    invitation_id: z.int(),
    user_id: z.int()
});

export const zAddByRefRequest = z.object({
    tg_ref_code: z.string()
});

export const zAppFeedbackCommentRequest = z.object({
    app_version: z.string(),
    platform: z.enum([
        'telegram',
        'android',
        'ios',
        'browser'
    ]),
    store: z.enum([
        'google-play',
        'rustore',
        'app-store',
        'none'
    ]),
    text: z.string().min(1).max(500)
});

export const zAppFeedbackRatingRequest = z.object({
    app_version: z.string(),
    platform: z.enum([
        'telegram',
        'android',
        'ios',
        'browser'
    ]),
    rating: z.int().gte(1).lte(5),
    store: z.enum([
        'google-play',
        'rustore',
        'app-store',
        'none'
    ])
});

export const zAvatarUrls = z.object({
    large: z.url().min(1),
    medium: z.url().min(1),
    small: z.url().min(1)
});

export const zBlockResponse = z.object({
    message: z.string(),
    status: z.string()
});

export const zBlockUserRequest = z.object({
    friend_id: z.int(),
    from_user_id: z.int(),
    to_user_id: z.int(),
    user_id: z.int()
});

export const zCardLikeNotificationData = z.object({
    card_id: z.int(),
    like_count: z.int().gte(1)
});

export const zCardLikeNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zCardLikeNotificationData,
    name: z.enum(['card_like']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zCardStarNotificationData = z.object({
    card_id: z.int(),
    feed_category: z.enum(['regular', 'qotd']),
    star_count: z.int().gte(1)
});

export const zCardStarNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zCardStarNotificationData,
    name: z.enum(['card_star']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zCharacterMessageNotificationData = z.object({
    character: z.enum([
        'luni',
        'sola',
        'mars'
    ]),
    text: z.string().min(1)
});

export const zCharacterMessageNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zCharacterMessageNotificationData,
    name: z.enum(['character_message']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zConfirmSearchRequest = z.object({
    user_relationship_id: z.int().gte(1)
});

export const zCreateInvitationRequest = z.object({
    demean: z.string(),
    user_id: z.int()
});

export const zCreateInvitationResponse = z.object({
    tg_invite_message_id: z.string().nullable(),
    tg_ref_code: z.string().min(1)
});

export const zCreateRequest = z.object({
    text: z.string().min(1).max(500)
});

export const zCurrentPayload = z.object({
    friend_answer: z.string().min(1).nullable(),
    scenario_id: z.int(),
    text: z.string().min(1)
});

export const zEasyMatchSkipInputBody = z.object({
    gender_preference: z.enum([
        'any',
        'not-important',
        'female',
        'male'
    ]),
    user_id: z.int(),
    user_relationship_id: z.int().gte(1)
});

export const zEasyMatchStartInputBody = z.object({
    gender_preference: z.enum([
        'any',
        'not-important',
        'female',
        'male'
    ]),
    user_id: z.int()
});

export const zEmptyNotificationData = z.record(z.string(), z.never());

export const zAgeVerifiedByModeratorNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['age_verified_by_moderator']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zChatWithLuniNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['chat_with_luni']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zDiaryEntryNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['diary_entry']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zEmailBackupNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['email_backup']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zErrorDetail = z.object({
    location: z.string().optional(),
    message: z.string().optional(),
    value: z.unknown().optional()
});

export const zErrorModel = z.object({
    code: z.enum([
        'not_ready',
        'age_required',
        'age_mismatch',
        'trust_gate'
    ]),
    detail: z.string().optional(),
    errors: z.array(zErrorDetail).nullish(),
    instance: z.url().optional(),
    permission: z.enum([
        'easy_match_search',
        'social_match_search',
        'social_match_accept',
        'easy_match_chat',
        'chat_found_friends',
        'stream_post'
    ]).optional(),
    status: z.int().optional(),
    title: z.string().optional(),
    type: z.url().optional().default('about:blank')
});

export const zFriendBlockedByNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['friend_blocked_by']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendBlockedNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['friend_blocked']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendConfirmedNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['friend_confirmed']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendDeclineBody = z.object({
    result: z.enum(['ok'])
});

export const zFriendMatchCommandInputBody = z.object({
    user_id: z.int()
});

export const zFriendMessageNotificationData = z.object({
    friend_id: z.int(),
    is_friend: z.boolean()
});

export const zFriendMessageNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zFriendMessageNotificationData,
    name: z.enum(['friend_message']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendPreview = z.object({
    avatar_emoji: z.string().nullable(),
    avatar_urls: zAvatarUrls,
    is_online: z.boolean(),
    luni_lastname: z.string().nullable(),
    luni_name: z.string()
});

export const zEasyPendingFeedbackMatch = z.object({
    friend: zFriendPreview,
    user_relationship_id: z.int()
});

export const zEasyPendingFeedback = z.object({
    matches: z.array(zEasyPendingFeedbackMatch).min(1),
    request_id: z.string().min(1)
}).nullable();

export const zFriendQueuedNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['friend_queued']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendRank = z.object({
    tier: z.enum([
        'caterpillar',
        'yogurt',
        'turbo',
        'samurai',
        'legend',
        'planet',
        'monster'
    ])
});

export const zFriendCardProjection = z.object({
    age: z.int().gte(0).nullable(),
    avatar_emoji: z.string().nullable(),
    avatar_urls: zAvatarUrls,
    gender: z.union([z.literal(1), z.literal(2)]),
    id: z.int(),
    is_online: z.boolean(),
    luni_lastname: z.string().nullable(),
    luni_name: z.string(),
    rank: zFriendRank,
    source: z.enum([
        'luni-search',
        'invitation',
        'social-match'
    ])
});

export const zBlockedNoMessagePayload = z.object({
    friend: zFriendCardProjection
}).nullable();

export const zFriendScenarios = z.object({
    played: z.int().gte(0).lte(7),
    proposal: z.enum([
        'none',
        'outgoing',
        'incoming'
    ])
});

export const zAcceptResult = z.object({
    scenarios: zFriendScenarios
});

export const zFriendSearchInfo = z.object({
    pending: z.int().gte(0)
});

export const zGate = z.object({
    reason: z.enum([
        'not_ready',
        'age_required',
        'age_mismatch',
        'trust_gate'
    ])
}).nullable();

export const zInvitationAttempts = z.object({
    attempts: z.int().nullable(),
    days_left: z.int().nullable(),
    hours_left: z.int().nullable()
});

export const zInvitationStatsResponse = z.object({
    invitation: zInvitationAttempts
});

export const zLegacyNotification = z.object({
    fromUserId: z.int(),
    message: z.string(),
    status: z.string(),
    timestamp: z.string(),
    toUserId: z.int()
});

export const zLegacyNotificationsResponse = z.object({
    count: z.int(),
    error: z.string().optional(),
    notifications: z.array(zLegacyNotification).nullable(),
    unread_count: z.int()
});

export const zLuniDialogueProgress = z.object({
    completed: z.int().gte(0),
    completed_at: z.iso.datetime({ offset: true }).nullable(),
    required: z.int().gte(0),
    visible: z.boolean()
});

export const zEasyMatchStatusResponse = z.object({
    blocked_no_message: zBlockedNoMessagePayload,
    gate: zGate,
    luni_dialogue_progress: zLuniDialogueProgress,
    pending_feedback: zEasyPendingFeedback,
    ready_for_search: z.boolean(),
    search: zFriendSearchInfo
});

export const zMatchFeedbackSkipRequest = z.object({
    request_id: z.string().min(1)
});

export const zMatchFeedbackSubmitRequest = z.object({
    comment: z.string().max(500),
    rating: z.int().gte(1).lte(5),
    request_id: z.string().min(1)
});

export const zMatchResultBody = z.object({
    result: z.enum([
        'available',
        'declined',
        'expired',
        'unverified'
    ])
});

export const zNewSpinsNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['new_spins']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zNotificationResponseInputBody = z.object({
    name: z.enum([
        'chat_with_luni',
        'vpn',
        'email_backup',
        'trust_gate',
        'age_verified_by_moderator',
        'trust_gate_confirmed_by_system',
        'trust_gate_confirmed_by_friend',
        'subscription',
        'friend_request_notification',
        'friend_response_notification',
        'card_like',
        'card_star',
        'character_message',
        'question_of_the_day',
        'rank_change',
        'friend_message',
        'voice_message',
        'diary_entry',
        'personality_ready',
        'scenario_offered',
        'scenario_answered',
        'scenario_circle',
        'vpn_gift',
        'new_spins',
        'friend_queued',
        'friend_found',
        'friend_added',
        'friend_confirmed',
        'friend_blocked',
        'friend_blocked_by',
        'search_blocked_pending',
        'search_blocked_no_message',
        'social_match_skippable_notification',
        'social_match_unskippable_notification',
        'social_match_revoked_notification',
        'social_match_timeout_notification',
        'social_match_rejected_notification'
    ]).optional(),
    source: z.enum([
        'push',
        'app',
        'telegram'
    ]).optional(),
    status: z.enum([
        'opened',
        'closed',
        'skipped'
    ])
});

export const zOnlineUsersResponse = z.object({
    count: z.int(),
    online_users: z.array(z.int()).nullable()
});

export const zPendingItem = z.object({
    friend_answer: z.string().min(1).nullable(),
    friend_id: z.int(),
    proposal: z.enum(['outgoing', 'incoming']),
    scenario_id: z.int(),
    text: z.string().min(1)
});

export const zPermissionsChangedNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['permissions_changed']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zPersonalityArchetype = z.object({
    description: z.string().min(1),
    id: z.enum([
        'seeker',
        'creator',
        'realist',
        'jester',
        'aesthete',
        'support',
        'thinker',
        'rebel',
        'achiever',
        'leader',
        'dreamer',
        'visionary'
    ]),
    label: z.string().min(1)
});

export const zPersonalityReadyNotificationData = z.object({
    archetype: zPersonalityArchetype,
    kind: z.enum(['first', 'update'])
});

export const zPersonalityReadyNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zPersonalityReadyNotificationData,
    name: z.enum(['personality_ready']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zProposeResult = z.object({
    scenarios: zFriendScenarios
});

export const zQuestionOfTheDayNotificationData = z.object({
    question: z.string().min(1)
});

export const zQuestionOfTheDayNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zQuestionOfTheDayNotificationData,
    name: z.enum(['question_of_the_day']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zRankChangeTo = z.object({
    points_to_next: z.int().nullable(),
    tier: z.enum([
        'caterpillar',
        'yogurt',
        'turbo',
        'samurai',
        'legend',
        'planet',
        'monster'
    ])
});

export const zRankChangeRank = z.object({
    to: zRankChangeTo
});

export const zRankChangeNotificationData = z.object({
    change_type: z.enum([
        'up',
        'down',
        'assigned'
    ]),
    rank: zRankChangeRank
});

export const zRankChangeNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zRankChangeNotificationData,
    name: z.enum(['rank_change']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zRejectInvitationRequest = z.object({
    invitation_id: z.int(),
    user_id: z.int()
});

export const zScenarioAcceptRequest = z.object({
    button: z.enum(['continue', 'decline']),
    user_id: z.int()
});

export const zScenarioFriendNotificationData = z.object({
    friend_id: z.int()
});

export const zScenarioAnsweredNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zScenarioFriendNotificationData,
    name: z.enum(['scenario_answered']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zScenarioCircleNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zScenarioFriendNotificationData,
    name: z.enum(['scenario_circle']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zScenarioOfferedNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zScenarioFriendNotificationData,
    name: z.enum(['scenario_offered']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zScenarioProposeRequest = z.object({
    answer: z.string().min(1).regex(/\S/),
    scenario_id: z.int(),
    user_id: z.int()
});

export const zSearchBlockedPendingNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['search_blocked_pending']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zSimulationStats = z.object({
    bored: z.int().gte(0),
    conflict: z.int().gte(0),
    great: z.int().gte(0),
    long_term_chance: z.int().gte(75).lte(90),
    total: z.int().gte(400).lte(600)
});

export const zSocialMatchCommandInputBody = z.object({
    notification_id: z.int(),
    user_id: z.int()
});

export const zSocialMatchInfo = z.object({
    attempts: z.int().gte(0).nullable(),
    pending: z.int().gte(0).lte(1)
});

export const zSocialMatchReason = z.object({
    learning_goal: z.string().min(1).max(500).optional(),
    offered_expertise: z.string().min(1).max(500).optional(),
    shared_activity: z.string().min(1).max(500).optional()
}).nullable();

export const zSocialMatchRejectedNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['social_match_rejected_notification']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zSocialMatchRevokedNotificationData = z.object({
    proposal_id: z.int()
});

export const zSocialMatchRevokedNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zSocialMatchRevokedNotificationData,
    name: z.enum(['social_match_revoked_notification']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zSocialMatchStartRequest = z.object({
    user_id: z.int()
});

export const zSocialMatchStartResponse = z.object({
    status: z.enum([
        'ok',
        'not_ready',
        'age_required',
        'age_mismatch',
        'trust_gate',
        'search_blocked_no_message',
        'search_blocked_pending',
        'quota_used'
    ])
});

export const zSocialMatchSubmitRequest = z.object({
    reason: zSocialMatchReason,
    request: z.string().min(1).max(500),
    user_id: z.int()
});

export const zSocialMatchSubmitResponse = z.object({
    status: z.enum([
        'ok',
        'not_ready',
        'age_required',
        'age_mismatch',
        'trust_gate',
        'quota_used',
        'search_blocked_no_message',
        'search_blocked_pending'
    ])
});

export const zSocialMatchTimeoutNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['social_match_timeout_notification']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zSocialPendingFeedback = z.object({
    friend: zFriendCardProjection,
    request_id: z.string().min(1)
}).nullable();

export const zSocialMatchStatusResponse = z.object({
    blocked_no_message: zBlockedNoMessagePayload,
    gate: zGate,
    luni_dialogue_progress: zLuniDialogueProgress,
    pending_feedback: zSocialPendingFeedback,
    social_match: zSocialMatchInfo,
    started_at: z.iso.datetime({ offset: true }).nullable()
});

export const zStatusResponse = z.object({
    status: z.string()
});

export const zStreamAuthor = z.object({
    avatar_urls: zAvatarUrls,
    id: z.int(),
    name: z.string().min(1)
});

export const zStreamMessage = z.object({
    author: zStreamAuthor,
    created_at: z.iso.datetime({ offset: true }),
    id: z.int(),
    is_own: z.boolean(),
    starred: z.boolean(),
    stars_count: z.int().gte(0),
    text: z.string().min(1)
});

export const zStreamListResponse = z.object({
    has_more_after: z.boolean(),
    has_more_before: z.boolean(),
    items: z.array(zStreamMessage).nullable(),
    next_after_id: z.int().nullable(),
    next_before_id: z.int().nullable()
});

export const zStreamStatusResponse = z.object({
    has_new: z.boolean()
});

export const zSubscriptionInfo = z.object({
    active: z.boolean(),
    plan: z.enum(['premium']).nullable()
});

export const zFriendOut = z.object({
    age: z.int().gte(0).nullable(),
    avatar_emoji: z.string().nullable(),
    avatar_urls: zAvatarUrls,
    blocked: z.boolean(),
    blocked_reason: z.enum(['temp_blocked', 'system_blocked']).nullable(),
    city: z.string().nullable(),
    expertise: z.string().nullable(),
    gender: z.union([z.literal(1), z.literal(2)]),
    id: z.int(),
    interests: z.string().nullable(),
    is_archived: z.boolean(),
    is_invisible: z.boolean(),
    is_online: z.boolean(),
    last_seen_at: z.iso.datetime({ offset: true }).nullable(),
    luni_lastname: z.string().nullable(),
    luni_name: z.string(),
    rank: zFriendRank,
    relationship_created_at: z.iso.datetime({ offset: true }),
    scenarios: zFriendScenarios,
    search_languages: z.array(z.string()),
    source: z.enum([
        'luni-search',
        'invitation',
        'social-match'
    ]),
    status: z.enum([
        'friends',
        'circle',
        'outgoing',
        'incoming',
        'blocked',
        'blocked_by'
    ]),
    subscription: zSubscriptionInfo,
    unread_board: z.boolean()
});

export const zFriendRelationshipNotificationData = z.object({
    friend: zFriendOut,
    user_relationship_id: z.int()
});

export const zFriendAddedNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zFriendRelationshipNotificationData,
    name: z.enum(['friend_added']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendFoundNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zFriendRelationshipNotificationData,
    name: z.enum(['friend_found']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendRequestNotificationData = z.object({
    demean: z.string().min(1).nullable(),
    friend: zFriendOut,
    invitation_id: z.int()
});

export const zFriendRequestNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zFriendRequestNotificationData,
    name: z.enum(['friend_request_notification']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendResponseNotificationData = z.object({
    friend: zFriendOut,
    status: z.enum(['accepted'])
});

export const zFriendResponseNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zFriendResponseNotificationData,
    name: z.enum(['friend_response_notification']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zFriendsResponse = z.object({
    friends: z.array(zFriendOut)
});

export const zSearchBlockedNoMessageNotificationData = z.object({
    friend: zFriendOut
});

export const zSearchBlockedNoMessageNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zSearchBlockedNoMessageNotificationData,
    name: z.enum(['search_blocked_no_message']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zSocialMatchOfferNotificationData = z.object({
    friend: zFriendOut,
    proposal_id: z.int(),
    simulation_results: zSimulationStats
});

export const zSocialMatchSkippableNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zSocialMatchOfferNotificationData,
    name: z.enum(['social_match_skippable_notification']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zSocialMatchUnskippableNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zSocialMatchOfferNotificationData,
    name: z.enum(['social_match_unskippable_notification']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zSubscriptionNotificationData = z.object({
    type: z.enum(['7_days_reward', '7_days_reward_expired'])
});

export const zSubscriptionNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zSubscriptionNotificationData,
    name: z.enum(['subscription']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zTrustGateConfirmedByFriendNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['trust_gate_confirmed_by_friend']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zTrustGateConfirmedBySystemNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['trust_gate_confirmed_by_system']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zTrustGateNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['trust_gate']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zUrlInfo = z.object({
    expires_at: z.iso.datetime({ offset: true }),
    url: z.url().min(1)
});

export const zUserStatusResponse = z.object({
    error: z.string().optional(),
    is_online: z.boolean().optional(),
    user_id: z.int().optional()
});

export const zVoiceMessageFriendBody = z.object({
    friend_id: z.int()
});

export const zVoiceMessageHoldIdBody = z.object({
    hold_id: z.string()
});

export const zVoiceMessageIdBody = z.object({
    friend_id: z.int(),
    message_id: z.string()
});

export const zVoiceMessageNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zFriendMessageNotificationData,
    name: z.enum(['voice_message']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zVoicePublishForm = z.object({
    client_message_id: z.string().min(1),
    file: z.string(),
    hold_id: z.string().min(1)
});

export const zVoiceSlot = z.union([
    z.object({
        phase: z.enum(['empty']),
        version: z.int().gte(0)
    }),
    z.object({
        holder_id: z.int(),
        phase: z.enum(['held']),
        version: z.int().gte(0)
    }),
    z.object({
        author_id: z.int(),
        duration_ms: z.int().gte(1).lte(180000),
        message_id: z.string().min(1),
        peaks: z.tuple([
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1),
            z.number().gte(0).lte(1)
        ]),
        phase: z.enum(['ready']),
        version: z.int().gte(0)
    })
]);

export const zHoldResult = z.object({
    hold_id: z.string().min(1),
    message: zVoiceSlot
});

export const zMessageBody = z.object({
    message: zVoiceSlot
});

export const zMessageWithUrl = z.object({
    message: zVoiceSlot,
    url: zUrlInfo.nullable()
});

export const zVpnGiftNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zEmptyNotificationData,
    name: z.enum(['vpn_gift']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zVpnNotificationData = z.object({
    vpn_key: z.string().min(1)
});

export const zVpnNotification = z.object({
    created_at: z.iso.datetime({ offset: true }),
    data: zVpnNotificationData,
    name: z.enum(['vpn']),
    notification_id: z.int().gte(1),
    type: z.enum(['notification'])
});

export const zWsBoardDenied = z.object({
    code: z.enum(['age_required', 'age_mismatch']),
    from_user_id: z.int(),
    permission: z.enum(['chat_found_friends']),
    type: z.enum(['board.denied'])
});

export const zWsClientBoardClosed = z.object({
    to_user_id: z.int(),
    type: z.enum(['board.closed'])
});

export const zWsClientBoardOpened = z.object({
    to_user_id: z.int(),
    type: z.enum(['board.opened'])
});

export const zWsClientBoardRead = z.object({
    to_user_id: z.int(),
    type: z.enum(['board.read'])
});

export const zWsClientSystemPong = z.object({
    message: z.null(),
    type: z.enum(['system.pong'])
});

export const zWsScenarioAccepted = z.object({
    friend_id: z.int(),
    scenarios: zFriendScenarios,
    type: z.enum(['scenario.accepted'])
});

export const zWsScenarioProposed = z.object({
    friend_id: z.int(),
    scenarios: zFriendScenarios,
    type: z.enum(['scenario.proposed'])
});

export const zWsStreamMessage = z.object({
    message: zStreamMessage,
    type: z.enum(['stream.message'])
});

export const zWsSystemPing = z.object({
    type: z.enum(['system.ping'])
});

export const zWsVoiceMessageUpdated = z.object({
    friend_id: z.int(),
    message: zVoiceSlot,
    type: z.enum(['voice.message.updated'])
});

export const zWsBoardContent = z.object({
    content: z.string()
});

export const zWsBoardOutgoingWithRead = z.object({
    content: z.string(),
    read: z.boolean()
});

export const zWsBoardInitialBoard = z.object({
    incoming: zWsBoardContent,
    outgoing: zWsBoardOutgoingWithRead
});

export const zWsBoardInitial = z.object({
    board: zWsBoardInitialBoard,
    from_user_id: z.int(),
    type: z.enum(['board.initial'])
});

export const zWsBoardRead = z.object({
    read: z.boolean()
});

export const zWsBoardTypingBoard = z.object({
    incoming: zWsBoardContent
});

export const zWsBoardTyping = z.object({
    board: zWsBoardTypingBoard,
    from_user_id: z.int(),
    type: z.enum(['board.typing'])
});

export const zWsBoardUpdateContentBoard = z.object({
    incoming: zWsBoardContent
});

export const zWsBoardUpdateContent = z.object({
    board: zWsBoardUpdateContentBoard,
    from_user_id: z.int(),
    kind: z.enum(['content']),
    type: z.enum(['board.update'])
});

export const zWsBoardUpdateReadBoard = z.object({
    outgoing: zWsBoardRead
});

export const zWsBoardUpdateReadReceipt = z.object({
    board: zWsBoardUpdateReadBoard,
    from_user_id: z.int(),
    kind: z.enum(['read_receipt']),
    type: z.enum(['board.update'])
});

export const zWsBoardUpdate = z.discriminatedUnion('kind', [
    zWsBoardUpdateContent.extend({ kind: z.literal('content') }),
    zWsBoardUpdateReadReceipt.extend({ kind: z.literal('read_receipt') })
]);

export const zWsClientTypingBoard = z.object({
    outgoing: zWsBoardContent
});

export const zWsClientBoardTyping = z.object({
    board: zWsClientTypingBoard,
    to_user_id: z.int(),
    type: z.enum(['board.typing'])
});

export const zWsClientMessage = z.discriminatedUnion('type', [
    zWsClientBoardTyping.extend({ type: z.literal('board.typing') }),
    zWsClientBoardOpened.extend({ type: z.literal('board.opened') }),
    zWsClientBoardClosed.extend({ type: z.literal('board.closed') }),
    zWsClientBoardRead.extend({ type: z.literal('board.read') }),
    zWsClientSystemPong.extend({ type: z.literal('system.pong') })
]);

export const zWsClientFrame = z.object({
    payload: zWsClientMessage
});

export const zWsNotification = z.discriminatedUnion('name', [
    zChatWithLuniNotification.extend({ name: z.literal('chat_with_luni') }),
    zVpnNotification.extend({ name: z.literal('vpn') }),
    zEmailBackupNotification.extend({ name: z.literal('email_backup') }),
    zTrustGateNotification.extend({ name: z.literal('trust_gate') }),
    zAgeVerifiedByModeratorNotification.extend({ name: z.literal('age_verified_by_moderator') }),
    zPermissionsChangedNotification.extend({ name: z.literal('permissions_changed') }),
    zTrustGateConfirmedBySystemNotification.extend({ name: z.literal('trust_gate_confirmed_by_system') }),
    zTrustGateConfirmedByFriendNotification.extend({ name: z.literal('trust_gate_confirmed_by_friend') }),
    zSubscriptionNotification.extend({ name: z.literal('subscription') }),
    zFriendRequestNotification.extend({ name: z.literal('friend_request_notification') }),
    zFriendResponseNotification.extend({ name: z.literal('friend_response_notification') }),
    zCardLikeNotification.extend({ name: z.literal('card_like') }),
    zCardStarNotification.extend({ name: z.literal('card_star') }),
    zCharacterMessageNotification.extend({ name: z.literal('character_message') }),
    zQuestionOfTheDayNotification.extend({ name: z.literal('question_of_the_day') }),
    zRankChangeNotification.extend({ name: z.literal('rank_change') }),
    zFriendMessageNotification.extend({ name: z.literal('friend_message') }),
    zVoiceMessageNotification.extend({ name: z.literal('voice_message') }),
    zDiaryEntryNotification.extend({ name: z.literal('diary_entry') }),
    zPersonalityReadyNotification.extend({ name: z.literal('personality_ready') }),
    zScenarioOfferedNotification.extend({ name: z.literal('scenario_offered') }),
    zScenarioAnsweredNotification.extend({ name: z.literal('scenario_answered') }),
    zScenarioCircleNotification.extend({ name: z.literal('scenario_circle') }),
    zVpnGiftNotification.extend({ name: z.literal('vpn_gift') }),
    zNewSpinsNotification.extend({ name: z.literal('new_spins') }),
    zFriendQueuedNotification.extend({ name: z.literal('friend_queued') }),
    zFriendFoundNotification.extend({ name: z.literal('friend_found') }),
    zFriendAddedNotification.extend({ name: z.literal('friend_added') }),
    zFriendConfirmedNotification.extend({ name: z.literal('friend_confirmed') }),
    zFriendBlockedNotification.extend({ name: z.literal('friend_blocked') }),
    zFriendBlockedByNotification.extend({ name: z.literal('friend_blocked_by') }),
    zSearchBlockedPendingNotification.extend({ name: z.literal('search_blocked_pending') }),
    zSearchBlockedNoMessageNotification.extend({ name: z.literal('search_blocked_no_message') }),
    zSocialMatchSkippableNotification.extend({ name: z.literal('social_match_skippable_notification') }),
    zSocialMatchUnskippableNotification.extend({ name: z.literal('social_match_unskippable_notification') }),
    zSocialMatchRevokedNotification.extend({ name: z.literal('social_match_revoked_notification') }),
    zSocialMatchTimeoutNotification.extend({ name: z.literal('social_match_timeout_notification') }),
    zSocialMatchRejectedNotification.extend({ name: z.literal('social_match_rejected_notification') })
]);

export const zWsPresenceBoard = z.object({
    incoming: zWsBoardRead
}).nullable();

export const zWsPresenceUpdate = z.object({
    board: zWsPresenceBoard,
    is_online: z.boolean(),
    last_seen_at: z.iso.datetime({ offset: true }).nullable(),
    type: z.enum(['presence.update']),
    user_id: z.int()
});

export const zWsSystemErrorBody = z.object({
    code: z.enum([
        'INVALID_TOKEN',
        'TOKEN_MISSING',
        'INVALID_MESSAGE',
        'MESSAGE_TOO_LARGE',
        'RATE_LIMITED',
        'TOO_MANY_CONNECTIONS',
        'CAN_NOT_MESSAGE',
        'INTERNAL_ERROR',
        'SLOW_CONSUMER',
        'UNSUPPORTED_PROTOCOL_VERSION'
    ]),
    message: z.string(),
    reason: z.string().optional()
});

export const zWsSystemError = z.object({
    error: zWsSystemErrorBody,
    type: z.enum(['system.error'])
});

export const zWsServerMessage = z.union([
    zWsPresenceUpdate,
    zWsBoardInitial,
    zWsBoardUpdate,
    zWsBoardTyping,
    zWsBoardDenied,
    zWsScenarioProposed,
    zWsScenarioAccepted,
    zWsVoiceMessageUpdated,
    zWsStreamMessage,
    zWsSystemPing,
    zWsSystemError,
    zWsNotification
]);

/**
 * OK
 */
export const zBlockUserChatResponse = zBlockResponse;

/**
 * No Content
 */
export const zFriendInvitationAcceptResponse = z.void();

/**
 * No Content
 */
export const zFriendInvitationAddByRefResponse = z.void();

/**
 * OK
 */
export const zFriendInvitationCreateResponse = zCreateInvitationResponse;

/**
 * OK
 */
export const zFriendInvitationRejectResponse = zStatusResponse;

/**
 * OK
 */
export const zFriendInvitationStatsResponse = zInvitationStatsResponse;

/**
 * No Content
 */
export const zAppFeedbackCommentResponse = z.void();

/**
 * No Content
 */
export const zAppFeedbackRatingResponse = z.void();

/**
 * OK
 */
export const zBlockUserResponse = zBlockResponse;

/**
 * No Content
 */
export const zEasyMatchStartResponse = z.void();

/**
 * OK
 */
export const zEasyMatchConfirmResponse = zMatchResultBody;

/**
 * OK
 */
export const zEasyMatchFeedbackResponse = zEasyMatchStatusResponse;

/**
 * OK
 */
export const zEasyMatchFeedbackSkipResponse = zEasyMatchStatusResponse;

/**
 * OK
 */
export const zEasyMatchSkipResponse = zMatchResultBody;

/**
 * OK
 */
export const zGetEasyMatchStatusResponse = zEasyMatchStatusResponse;

/**
 * OK
 */
export const zListFriendsResponse = zFriendsResponse;

/**
 * OK
 */
export const zArchiveFriendByIdResponse = zFriendDeclineBody;

/**
 * No Content
 */
export const zBlockFriendByIdResponse = z.void();

/**
 * OK
 */
export const zDeclineFriendMatchResponse = zFriendDeclineBody;

/**
 * OK
 */
export const zOpenFriendMatchResponse = zMatchResultBody;

/**
 * OK
 */
export const zUnarchiveFriendByIdResponse = zFriendDeclineBody;

/**
 * No Content
 */
export const zUnblockFriendByIdResponse = z.void();

/**
 * No Content
 */
export const zNotificationResponseResponse = z.void();

/**
 * OK
 */
export const zLegacyNotificationsLuniResponse = zLegacyNotificationsResponse;

/**
 * OK
 */
export const zOnlineUsersLuniResponse = zOnlineUsersResponse;

/**
 * OK
 */
export const zListPendingFriendsResponse = z.array(zFriendOut).nullable();

/**
 * OK
 */
export const zScenarioPendingResponse = z.array(zPendingItem);

/**
 * OK
 */
export const zScenarioCurrentResponse = zCurrentPayload;

/**
 * OK
 */
export const zScenarioAcceptResponse = zAcceptResult;

/**
 * OK
 */
export const zScenarioProposeResponse = zProposeResult;

/**
 * OK
 */
export const zSubmitSocialMatchResponse = zSocialMatchSubmitResponse;

/**
 * OK
 */
export const zSocialMatchConfirmResponse = zMatchResultBody;

/**
 * OK
 */
export const zSocialMatchFeedbackResponse = zSocialMatchStatusResponse;

/**
 * OK
 */
export const zSocialMatchFeedbackSkipResponse = zSocialMatchStatusResponse;

/**
 * OK
 */
export const zSocialMatchLaterResponse = zMatchResultBody;

/**
 * OK
 */
export const zSocialMatchOpenResponse = zMatchResultBody;

/**
 * OK
 */
export const zSocialMatchSkipResponse = zMatchResultBody;

/**
 * OK
 */
export const zStartSocialMatchResponse = zSocialMatchStartResponse;

/**
 * OK
 */
export const zGetSocialMatchStatusResponse = zSocialMatchStatusResponse;

/**
 * OK
 */
export const zListStreamResponse = zStreamListResponse;

/**
 * Created
 */
export const zCreateStreamMessageResponse = zStreamMessage;

/**
 * No Content
 */
export const zHideStreamMessageResponse = z.void();

/**
 * No Content
 */
export const zReportStreamMessageResponse = z.void();

/**
 * OK
 */
export const zStarStreamMessageResponse = zStreamMessage;

/**
 * OK
 */
export const zStreamStatusResponse2 = zStreamStatusResponse;

/**
 * OK
 */
export const zUserStatusLuniResponse = zUserStatusResponse;

/**
 * OK
 */
export const zLuniVoiceMessageGetResponse = zMessageWithUrl;

/**
 * OK
 */
export const zLuniVoiceMessageDeleteResponse = zMessageBody;

/**
 * OK
 */
export const zLuniVoiceMessageFinishResponse = zMessageBody;

/**
 * OK
 */
export const zLuniVoiceMessageHoldResponse = zHoldResult;

/**
 * OK
 */
export const zLuniVoiceMessagePublishResponse = zMessageBody;

/**
 * OK
 */
export const zLuniVoiceMessageReleaseResponse = zMessageBody;

/**
 * OK
 */
export const zLuniVoiceMessageUrlResponse = zUrlInfo;

/**
 * OK
 */
export const zLegacyNotificationsResponse2 = zLegacyNotificationsResponse;

/**
 * OK
 */
export const zOnlineUsersResponse2 = zOnlineUsersResponse;

/**
 * OK
 */
export const zUserStatusResponse2 = zUserStatusResponse;
